export enum ClaimType {
  NoneApplicable = 0,
  NoneAdded = 1,
  Free = 2,
  VeryLow = 4,
  Low = 8,
  Lean = 16,
  ExtraLean = 32,
  GoodSource = 64,
  SourceContains = 128,
  High = 256,
  ExcellentSource = 512,
}
